import React, { useState } from 'react';

import { ReactComponent as ArrowButton } from '../../images/icons/right-arrow-button.svg';
import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './Slider.module.scss';

export default function Slider({ section }) {
  const [activeSlide, setActiveSlide] = useState(0);

  const handleSlideChange = (direction) => {
    if (direction === 'next') {
      if (activeSlide === section.content.length - 1) {
        setActiveSlide(0);
      } else {
        setActiveSlide(activeSlide + 1);
      }
    } else if (direction === 'previous') {
      if (activeSlide === 0) {
        setActiveSlide(section.content.length - 1);
      } else {
        setActiveSlide(activeSlide - 1);
      }
    }
  };

  return (
    <PageSection className={styles.slider} data-analytics-section={'slider'}>
      <div className={styles.card}>
        <div className={styles.arrows} data-analytics-component={'arrow-buttons'}>
          <button style={{ transform: 'scaleX(-1)' }} onClick={() => handleSlideChange('previous')}>
            <ArrowButton />
          </button>
          <button onClick={() => handleSlideChange('next')}>
            <ArrowButton />
          </button>
        </div>

        <div
          className={styles.pagination}
          style={{ gridTemplateColumns: `repeat(${section.content.length}, 1fr)` }}
          data-analytics-component={'pagination'}
        >
          {section.content.map((_, i) => (
            <button key={i} className={i === activeSlide ? styles.active : ''} onClick={() => setActiveSlide(i)} />
          ))}
        </div>

        <div className={styles.slides} style={{ transform: `translateX(-${activeSlide * 200}%)` }}>
          {section.content.map((slide, i) => (
            <div
              key={i}
              className={styles.slide}
              style={{
                opacity: i === activeSlide ? 1 : 0,
                transitionDuration: activeSlide === 0 ? '750ms' : '300ms',
              }}
              data-analytics-component={'slide'}
              data-analytics-id={slide.title}
            >
              <a href={slide.wistiaUrl} target="_blank">
                <ContentfulImage imageFragment={slide.mainImage} />
              </a>
              <div className={styles.content}>
                <span className={styles.eyebrow}>{slide.subtitle}</span>
                <h2 className={styles.videoTitle}>{slide.title}</h2>
                <RichTextConverter copy={slide.copy} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </PageSection>
  );
}
